var waiting_list_button = ( function( $ ) {

	var $button;
	var post_id;
	var list;

	var _init = function() {
		$button = $( '.book-now' );
		if ( $button.hasClass( 'disabled' ) || $button.hasClass( 'logged-out' ) ) {
			return;
		}

		if ( $button.hasClass( 'fully-booked' ) ) {
			list = 'waiting';
		} else if ( $button.hasClass( 'express-interest' ) ) {
			list = 'expressed_interest';
		} else {
			return;
		}

		post_id = $button.data( 'id' );
		$button.on( 'click', _call_ajax );
	};

	var _call_ajax = function( e ) {
		e.preventDefault();

		$.post( ScriptData.ajaxurl, {
			action: 'crate_add_to_waiting_list',
			nonce: ScriptData.add_to_waiting_list_nonce,
			post_id: post_id,
			list: list
		}, _on_success ).fail( ( jqXHR, textStatus, errorThrown ) => _on_failure( errorThrown ) )
	};

	var _on_success = function( response ) {
		if ( !response.success ) {
			$( '.error-message' ).removeClass( 'hidden' );
			return;
		}

		$button.addClass( "disabled" );
		if ( list == 'waiting' ) {
			$button.text( "You've Been Added To The Waiting List" );
		} else if ( list == 'expressed_interest' ) {
			$button.text( 'You Have Expressed interest' );
		}
	}

	var _on_failure = function( error ) {
		$( "<p class='error'>Request failed</p>" ).insertAfter( $button );
	}

	if ( $( '.book-now' ).length > 0 ) {
		_init();
	}
	return {};

} )( jQuery );

module.exports = waiting_list_button;